import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import VehicleView, { VehicleViewProps } from "./VehicleView";

export interface OwnProps {
  viewProps: VehicleViewProps;
}
type Props = OwnProps & AppModalProps;

export function VehicleViewModal({ viewProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <VehicleView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              ...viewProps?.displayProps,
            }}
            onDelete={() => {
              modalProps.onClose && modalProps.onClose({}, "escapeKeyDown");
            }}
            onClose={() => {
              modalProps.onClose && modalProps.onClose({}, "backdropClick");
              viewProps.onClose && viewProps.onClose();
            }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
